'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 手Q官方文档：http://open.mobile.qq.com/api/common/index
 */
var MobileQQ = function () {
    function MobileQQ() {
        _classCallCheck(this, MobileQQ);

        this.type = 'mobileqq';
        this.keeper = undefined;
    }

    _createClass(MobileQQ, [{
        key: 'supportGeo',
        value: function supportGeo() {
            return (/(.*?(iPad|iPhone|iPod).*?QQ\/([\d\.]+).*?)|(.*?\bV1_AND_SQI?_([\d\.]+)(.*?QQ\/([\d\.]+))?.*?)/i.test(navigator.userAgent)
            );
        }
    }, {
        key: 'process',
        value: function process(succ, fail, next) {
            var _this = this;

            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            if (!this.supportGeo()) return next();
            opt.trigger = function (token) {
                // API超时
                fail({
                    code: 408,
                    message: _this.type + ' API Timeout:' + opt.timeout,
                    type: _this.type
                }, token);
            };
            this.keeper = new _keeper2.default(opt);

            _util2.default.loadScript('//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
                try {
                    if (!mqq.support('mqq.sensor.getLocation')) return fail({
                        code: 412, // API不支持归类为`未命中`
                        type: _this.type
                    }, _this.keeper.getToken());
                    mqq.sensor.getLocation({
                        allowCacheTime: 60 // 设置缓存时间（秒）
                    }, function (retCode, latitude, longitude, status) {
                        if (retCode == 0 && latitude && longitude) {
                            succ({
                                lat: latitude,
                                lng: longitude,
                                geoType: 'gcj02',
                                type: _this.type
                            }, _this.keeper.getToken());
                        } else {
                            var msg = ['retCode:' + retCode];
                            if (status) {
                                // FIXME: >= IOS 4.7
                                msg.push('authroized:' + status.authroized);
                                msg.push('sensor:' + status.enabled);
                            }
                            fail({
                                // code: status && !status.authroized ? 401 : 500, // TODO: authroized为Number类型，与文档不符合
                                code: status && !status.enabled && 407,
                                message: msg.join(' '),
                                type: _this.type
                            }, _this.keeper.getToken());
                        }
                    });
                } catch (e) {
                    fail({
                        code: 400,
                        message: e && e.message || JSON.stringify(e),
                        type: _this.type
                    }, _this.keeper.getToken());
                }
            });
        }
    }]);

    return MobileQQ;
}();

var instance = new MobileQQ();
module.exports = instance.process.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/mobileqq.js
// module id = 397
// module chunks = 0